import "./App.css";
import LandingPage from "./components/landing/LandingPage";

function App() {
  return <LandingPage />;
}

export default App;
